<template>
  <el-dialog :title="$t('Components.QianHai.title')" :visible.sync="visible" :width="isPC ? '30%' : '100%'" destroy-on-close :close-on-click-modal="false" @close="dialogCloseCb">
    <!--加载Oceanpayment支付页面Div-->
    <div id="oceanpayment-element"></div>
    <el-button type="primary" @click="pay" style="width: 272px; margin: 0 auto;display: block;">{{$t('confirmOrder.payNow')}}</el-button>
  </el-dialog>
</template>

<script>
// const sha256 = require('js-sha256').sha256
import x2js from 'x2js'
import API from '@/api'
let self = null
// 前海开发者文档
// https://developers.oceanpayment.com/Docs/payment/service?id=114&key=%E4%BF%A1%E7%94%A8%E5%8D%A1&value=&type=1
export default {
  name: 'QianHai',
  data() {
    return {
      visible: false,
      isClickPay: false, // 是否点击了支付按钮
      timer: null,
      callNumber: 0,
      payParams: {
        account: process.env.VUE_APP_QIANHAI_ACCOUNT, // 账户号
        terminal: process.env.VUE_APP_QIANHAI_TERMINAL, // 终端号
        signValue: undefined,
        // 公钥
        key: process.env.VUE_APP_QIANHAI_KEY,
        order_number: undefined, // 订单号
        order_currency: 'USD', // 币种
        order_amount: undefined, // 交易金额
        backUrl: `${location.origin}/api/v1/payment/ocean/payment/back`, // 返回支付信息的网站URL地址
        noticeUrl: process.env.VUE_APP_QIANHAI_NOTICEURL, // 服务器回调URL地址，用于交易结果推送及其他业务状态推送
        methods: `${this.$t('Components.QianHai.CreditCard')}`, // 支付方式
        billing_lastName: undefined, // 持卡人名
        billing_firstName: undefined, // 持卡人姓
        billing_email: undefined, // 持卡人邮箱
        billing_country: undefined, // 持卡人国家
        billing_state: undefined, // 持卡人州/省
        billing_city: undefined, // 持卡人城市
        billing_address: undefined, // 持卡人地址
        billing_zip: undefined, // 持卡人邮编
        billing_ip: sessionStorage.getItem('ipLocation') && JSON.parse(sessionStorage.getItem('ipLocation')).ip,
        productName: undefined, // 产品名称
        productNum: undefined, // 数量
        productSku: undefined
      }
    }
  },
  created() {
    window.oceanpaymentCallBack = this.oceanpaymentCallBack.bind(this)
    self = this
  },
  methods: {
    show(payParams) {
      Object.assign(this.payParams, payParams)
      this.visible = true
      this.init()
    },
    close() {
      this.visible = false
    },
    init() {
      this.$nextTick(() => {
        // init的参数表示是否开启测试模式（沙盒）
        window.Oceanpayment.init(process.env.NODE_ENV !== 'production')
      })
    },
    /**
     * 弹窗关闭回调
     */
    dialogCloseCb() {
      if (!this.isClickPay) this.$emit('cancel') // 取消支付
      this.isClickPay = false
      this.clearTimer()
    },
    /**
     * 点击支付按钮
     */
    pay() {
      this.isClickPay = true
      const p = this.payParams
      this.getQianHaiSignValue({
        account: p.account,
        terminal: p.terminal,
        order_number: p.order_number,
        order_currency: p.order_currency,
        order_amount: p.order_amount,
        billing_firstName: p.billing_firstName,
        billing_lastName: p.billing_lastName,
        billing_email: p.billing_email
      }).then(signValue => {
        this.payParams.signValue = signValue
        // this.payParams.signValue = sha256(`${p.account}${p.terminal}${p.order_number}${p.order_currency}${p.order_amount}${p.billing_firstName}${p.billing_lastName}${p.billing_email}12345678`)
        window.Oceanpayment.checkout(this.payParams)
      }).catch(() => {
        this.$emit('fail')
      })
    },
    /**
     * 获取SignValue
     */
    getQianHaiSignValue(params) {
      return new Promise((resolve, reject) => {
        API.getQianHaiSignValue(params).then(result => {
          resolve(result.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 钱海支付回调
     */
    oceanpaymentCallBack(data) {
      const result = new x2js().xml2js(data)
      const status = +result.response.payment_status
      switch (status) {
        // -1:待处理（当pay_url字段不为空时，3D交易返回待处理）
        case -1:
          if (result.response.pay_url) {
            window.open(result.response.pay_url)
            this.getOrderState(result.response.order_number)
          }
          break
        // 0:支付失败
        case 0:
          this.$emit('fail')
          break
        // 1:支付成功
        case 1:
          this.$emit('success')
          break
      }
    },
    /**
     * 获取订单状态
     */
    getOrderState(id) {
      self.callNumber++
      if (self.callNumber > 20) {
        self.$emit('fail')
        self.close()
        return self.clearTimer()
      }
      API.getOrderState(id).then(result => {
        const status = +result.data.status
        if (status === 2) {
          self.$emit('success')
          self.close()
          self.clearTimer()
          return
        }
        if (status === -2 || status === -1) {
          self.$emit('fail')
          self.close()
          self.clearTimer()
          return
        }
        setTimeout(() => {
          self.getOrderState(id)
        }, 3000)
      }).catch(error => {
        console.error(error)
        self.$emit('fail')
      })
    },
    clearTimer() {
      this.callNumber = 0
      clearTimeout(this.timer)
      this.timer = null
    }
  }
}
</script>
<!--
response: {
  account: "995200"
  auth_code: ""
  auth_reason: ""
  card_country: "HK"
  card_number: "438366***6661"
  card_type: "Visa"
  methods: "Credit Card"
  notice_type: "transaction"
  order_amount: "1.50"
  order_currency: "USD"
  order_notes: ""
  order_number: "1000000010316"
  pay_url: "https://test-secure.oceanpayment.com:443/gateway/direct/redirect?pay_id=d40c6168ff216f4f227dcb70402636a87196b682f283d9e02cb9e21529840d4c"
  pay_userId: ""
  payment_amount: ""
  payment_authType: "2"
  payment_country: "CN"
  payment_details: "80093:3D Authorized Service not completed"
  payment_exchangeRate: ""
  payment_id: "211221140703568520000"
  payment_risk: ""
  payment_solutions: ""
  payment_status: "-1"
  push_dateTime: "2021-12-21 14:07:03"
  signValue: "74DCC64E672C93E3B71E2C81A748DBA58C727310B22F41171D92C4AEFB2862E3"
  terminal: "99520001"
}
 -->
